// src/API/rest.sendmails.ts
import { useMutation, useQueryClient } from '@tanstack/react-query';
import axios from 'axios';

interface SendMailsPayload {
  date: string; // e.g., "2025-12-01"
}

interface SendMailsResponse {
  success: boolean;
  message: string;
  data?: any;
}

// Helper to get token
const getAuthToken = (): string | null => {
  return localStorage.getItem('accessTocken');
};

// Axios instance with token interceptor
const apiClient = axios.create({
  baseURL: process.env.REACT_APP_BACKEND_URL,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Automatically add token to every request
apiClient.interceptors.request.use((config) => {
  const token = getAuthToken();
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

const sendForecastEmails = async (payload: SendMailsPayload): Promise<SendMailsResponse> => {
  const response = await apiClient.post('/transactions/forecast-calendar/send-email/', payload);
  return response.data;
};

export const useSendForecastEmails = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: sendForecastEmails,
    onSuccess: (data) => {
      queryClient.invalidateQueries({ queryKey: ['forecastCalender'] });
      alert(data.message || 'Emails sent successfully!');
    },
    onError: (error: any) => {
      const msg =
        error?.response?.data?.message ||
        error?.response?.data?.error ||
        error?.message ||
        'Failed to send emails';

      // If token expired (401), you can redirect to login
      if (error?.response?.status === 401) {
        alert('Session expired. Please log in again.');
        localStorage.removeItem('accessTocken');
        window.location.href = '/login';
        return;
      }

      alert('Error: ' + msg);
    },
  });
};